/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Grid, Box, Typography, Button } from '@mui/material';
import backgroundPic from '../../assets/images/bg.png';
import mainLogo from '../../assets/images/logo.png';
import './Auth.css';
import CustomTextField from '../../common/components/CustomTextField/CustomTextField';
import { fonts, themes } from '../../common/themes/themes';
import Loader from '../../common/Lottifiers/Loader/Loader';
import Compdirection from '../../common/themes/CompDirection';
import '../i18n';
import { useTranslation } from 'react-i18next';
import { changeApplang } from '../../common/configs/utils';
import MobileRedirect from '../../common/MobileRedirect/MobileRedirect';

interface DTOAuthProps {
  isLoading: boolean;
  onSubmitLogin(username: string, password: string): any;
}
function AuthPresenter({ onSubmitLogin, isLoading }: DTOAuthProps) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false)
  const handleLoginBtn = () => {
    onSubmitLogin(username, password);
  };

  const { t, i18n } = useTranslation();
  const trans: any = t;
  
  function changemainLang() {
    const newlang = i18n.language == 'en' ? 'ar' : 'en';
    i18n.changeLanguage(newlang);
    changeApplang(newlang, true);
  }

  return (
    <>
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleLoginBtn();
      }}
    >
      <Grid
        container
        sx={{
          backgroundImage: `url(${backgroundPic})`,
          width: '100vw',
          height: '100vh',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          overflow: 'hidden',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            paddingLeft: '8.313em',
            position: 'relative',
          }}
          className="main_logo"
        >
          <img src={mainLogo} />
        </Grid>
        <Grid
          item
          xs={12}
          sx={{
            paddingLeft: '45.313em',
            position: 'absolute',
          }}
        >
          <Box
            className={'login-box ' + i18n.language}
            dir={i18n.language == 'ar' ? 'rtl' : 'ltr'}
          >
            <Grid container>
              <Grid item xs={12} className="welcome-back">
                {trans('Welcome Back!')}
              </Grid>
              <Grid
                item
                xs={12}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Typography className="log-in">
                  {trans('Please log in to your account')}
                </Typography>
              </Grid>
              <Grid item xs={12} sx={{ padding: '20px' }}>
                <Compdirection>
                  <CustomTextField
                    placeholder={trans('Username')}
                    label={trans('Username')}
                    value={username}
                    onChange={(e: any) => setUsername(e.target.value)}
                    type="string"
                  />
                </Compdirection>
              </Grid>
              <Grid item xs={12} sx={{ padding: '20px' }}>
                <Compdirection>
                  <CustomTextField
                    placeholder={trans('Password')}
                    label={trans('Password')}
                    value={password}
                    onChange={(e: any) => setPassword(e.target.value)}
                    type={showPassword ? 'text' : 'password'}
                    InputProps={{
                      endAdornment: (
                        <i
                          className={`las ${showPassword ? 'la-eye-slash' : 'la-eye'} text-[#7C0E6F] text-2xl`}
                          onClick={() => setShowPassword(!showPassword)}
                          style={{ 
                            cursor: 'pointer' , 
                            color: "#7C0E6F",
                            fontSize: '1.5rem'
                          }}
                        ></i>
                      ),
                    }}
                    />
                </Compdirection>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Button
                  style={{
                    maxWidth: '275px',
                    width: 'auto',
                    fontFamily: fonts.fontFamily,
                    backgroundColor: themes.primaryMain,
                    boxShadow: '0px 3px 3px #00000061',
                    borderRadius: '4px',
                    opacity: 1,
                    fontSize: fonts.title,
                    textTransform: 'none',
                    color: 'white',
                    paddingLeft: '185px',
                    paddingRight: '185px',
                    paddingTop: '15px',
                    paddingBottom: '15px',
                    marginBottom: '2em',
                  }}
                  type="submit"
                >
                  {trans('Login')}
                </Button>
              </Grid>
              {isLoading && (
                <div style={{ marginLeft: '4em', marginTop: '-10em' }}>
                  <Loader height={100} width={300} />
                </div>
              )}
              <Grid item xs={12}>
                <Box
                  className="login-change-lang"
                  style={{
                    textAlign: 'center',
                    paddingRight: '0.5em',
                    paddingBottom: '0.5em',
                  }}
                >
                  <Typography
                    style={{
                      color: '#9E9E9E',
                      cursor: 'pointer',
                    }}
                    onClick={() => changemainLang()}
                  >
                    <a>
                      {i18n.language == 'ar'
                        ? 'Change to English'
                        : 'التغيير إلى اللغة العربية'}
                    </a>
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </form>
    <MobileRedirect/>
    </>
  );
}
export default AuthPresenter;
